/* eslint-disable prefer-destructuring */
import styled, { css } from "styled-components";
import { theme } from "../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint, getDirection } from "../../../../../../common-deprecated/themes/common";

export const Step = styled.span.attrs(() => ({
    className: "t-base-headline",
}))<{ isActive?: boolean; noPadding?: boolean; showLeftSeparator?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0;
    font-family: ${theme.fonts.base};
    font-size: 1.3rem;
    line-height: 2.4rem;
    text-align: center;
    color: ${theme.colors.grey7};

    @media ${getBreakpoint("up", "lg")} {
        align-items: center;
        justify-content: flex-start;
        font-family: ${theme.fonts.regular};
        font-size: 1.6rem;
        /* Hacky way to show the left separator in edge cases. */
        ${({ showLeftSeparator }) => showLeftSeparator && "&::before,"}
        &::after {
            display: inline-block;
            width: 20px;
            height: 1.5px;
            margin: 0 16px;
            content: "";
            background-color: ${theme.colors.grey3};
        }
    }

    ${({ isActive }) =>
        isActive &&
        css`
            color: ${theme.colors.primaryBlack};
            @media ${getBreakpoint("up", "lg")} {
                color: ${theme.colors.primaryBlack} !important;
            }
        `};
`;

export const Link = styled.a<{ disabledClick?: boolean; showLeftSeparator?: boolean }>`
    cursor: ${({ disabledClick: placeholder }) => (placeholder ? "initial" : "pointer")};
    &:first-child {
        margin-top: 0;
    }
    ${({ showLeftSeparator }) =>
        !showLeftSeparator &&
        css`
            &:first-child ${Step} {
                &::before {
                    display: none;
                }
            }
        `}
    &:last-child ${Step} {
        &::after {
            display: none;
        }
    }
`;

export const Icon = styled.span<{ isActive?: boolean }>`
    display: none;
    @media ${getBreakpoint("up", "lg")} {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 30px;
		margin-${getDirection("right")}: ${theme.space[2]}px;
		padding-bottom: 3px; /* To fix correct vertical alignment */
		font-family: ${theme.fonts.regular};
		font-size: 1.6rem;
        line-height: 2.4rem;
		color: ${theme.colors.grey7};
		${({ isActive }) =>
            isActive &&
            css`
                color: ${theme.colors.primaryRed};
            `};
	}
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: ${theme.space[3]}px 0;
    @media ${getBreakpoint("up", "lg")} {
        flex-direction: row;
        align-items: center;
        padding: ${theme.space[3]}px 0;
    }
    a {
        text-decoration: none;
    }
`;

export const Badge = styled.div<{ isActive?: boolean }>`
    float: left;
    margin: 0;
    margin-${getDirection("right")}: ${theme.space[2]}px;
    font-size: 1.3rem;
    line-height: 2.4rem;
    color: ${({ isActive }) => (isActive ? theme.colors.primaryBlack : theme.colors.grey3)};
    @media ${getBreakpoint("up", "lg")} {
      font-size: 1.6rem;
      color: ${({ isActive }) => (isActive ? theme.colors.primaryRed : theme.colors.grey7)};
    }
`;

export const ArrowButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin: 0 ${theme.space[1]}px;
    background: ${theme.colors.grey1};
    border-radius: 50%;
`;
